export const updateTime = 5 * 1000; 
export const problemsPerPage = 5;
export const tokenWhastapp = "essetokenvalida123";